import './index.less';
import App from './app';
export default App;
